import React from 'react';
import { Text } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { TabName } from '../../constant/size-table';
import { SizeMeasurementsTable } from './SizeMeasurementsTable';

type TableType = {
  title?: string;
  table: string[][];
}[];

interface Props {
  active_tab: TabName;
  tab_list: TabName[];
  table_list: TableType;
  onClickTab: (tab: TabName) => void;
}

export const OverseasDirectPurchaseSizeGuide = ({ active_tab, tab_list, table_list, onClickTab }: Props) => {
  return (
    <Container>
      <Text variant='Body_17_SemiBold' color='gray900'>
        해외 사이즈 가이드
      </Text>

      <Spacer height={12} />

      <Text variant='Body_14_Regular' color='textSecondary' style={{ lineHeight: '140%' }}>
        표준 사이즈를 기반으로 제공하는 참고용 가이드로 실측 사이즈 정보가 아니며 상품이나 개인 체형에 따라 차이가 있을
        수 있습니다.
      </Text>

      <Spacer height={28} />

      <Tabs>
        {tab_list.map((tab) => (
          <Tab key={tab} active={tab === active_tab} onClick={() => onClickTab(tab)}>
            {tab}
          </Tab>
        ))}
      </Tabs>

      <Spacer height={24} />

      {table_list.map(({ title, table }) => (
        <div key={JSON.stringify(table)}>
          {Boolean(title) && (
            <Text variant='Body_14_Regular' color='textTertiary'>
              - {title}
            </Text>
          )}
          <Spacer height={12} />
          {Boolean(table.length) && <SizeMeasurementsTable valueList={table} />}
        </div>
      ))}
    </Container>
  );
};

const Container = styled.div`
  padding: 32px 16px 104px 16px;
  background: ${vars.color.staticWhite};
`;

const Spacer = styled.div<{ height: number }>`
  width: 100%;
  height: ${({ height }) => height}px;
`;

const Tabs = styled.div`
  padding: 2px 1px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 40px;
  border-radius: 6px;
  border: 1px solid ${vars.color.fillTertiary};
  background: ${vars.color.fillTertiary};
`;

const Tab = styled.div<{ active?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 36px;
  font-size: 14px;
  border-radius: 4px;
  font-weight: ${({ active }) => (active ? 600 : 500)};
  color: ${({ active }) => (active ? vars.color.textStrong : vars.color.textTertiary)};
  background: ${({ active }) => (active ? vars.color.staticWhite : vars.color.fillTertiary)};
`;
